<template>
  <div>
    <div class="tosall">
      <div class="tos">
        <h3>
          ・
          当社のkintone×対面開発サービスに適しているかどうか診断させていただくために利用します。
        </h3>
        <h3>
          ・ お問合せの回答をお伝えするため、当社からのご連絡に利用します。
        </h3>
        <div class="texttos">
          提供の任意性<br />
          ご入力いただきました個人情報は、ご本人の意思でご提供下さい。<br />
          ただし、ご提供いただけない情報がある際には、お問合せいただいた内容についての十分な回答を行えない場合があります。<br />
          第三者への提供及び委託についてご入力いただきました個人情報は、外部の第三者への提供及び処理を委託することはありません。<br />
          開示等の求めについて
          当社は、当社の保有する個人データに関し、ご本人（代理人を含む）から開示・訂正又は削除・利用停止等に関するご要請があれば、ご本人の確認をさせていただいた上で、速やかに対応します。<br />
          また当社の個人情報の取り扱いに関するご質問、ご相談にも対応いたします。<br />
          ただしデータの削除については、法的な保管義務に抵触する場合にはご希望に添えない場合があります。<br /><br />

          当社の個人情報に関するお問合せは、以下の窓口で承ります。<br />
          お問合せの内容により必要な書類提出や質問へのご回答をお願いすることがあります。<br />
          なお手数料は無料です。<br />
          窓口の受付時間は平日の午前９時から午後５時までとさせていただきます。<br />
        </div>
        <br />
        <div class="center">
          <CheckBox CheckBox="同意する" For="nayamiUriage" :ischecked="this.checkbox.includes('同意する')"
            @change="setCheckbox" />
        </div>
        <br />
        <div class="texttos pink" v-show="show">
          ※同意していただいた場合のみご利用いただけます
        </div>
      </div>
      <BtnNomal BtnNomal="診断ページ" @click="shindan()" />
    </div>
  </div>
</template>

<script>
import BtnNomal from "@/atoms/BtnNomal.vue";
import CheckBox from "@/atoms/CheckBox.vue";
export default {
  name: "TOS",
  components: { BtnNomal, CheckBox },
  methods: {
    shindan() {
      this.show = false; //エラー非表示
      if (this.checkbox.length === 1) {
        //チェックがある
        this.$router.push("/shindan").catch(() => { });
      } else {
        this.show = true; //エラー
      }
    },
    check() {
      //年齢確認チェック
      this.show = false;
      if (this.checkbox.length === 1) {
        //年齢確認にチェックがある
        this.$router.push("/crateGirleProf").catch(() => { });
      } else {
        this.show = true; //年齢確認にチェックがない
      }
    },
    setCheckbox(checkObj) {
      //チェックボックス用
      console.log(checkObj);
      if (checkObj.ischecked === true) {
        this.checkbox.push(checkObj.checkboxName);
      } else {
        let index = this.checkbox.indexOf(checkObj.checkboxName);
        if (index >= 0) {
          this.checkbox.splice(index, 1);
        }
      }
      console.log(this.checkbox);
    },
  },
  data() {
    return {
      checkbox: [],
      show: false,
    };
  },
};
</script>

<style scoped>
.tos {
  display: inline-block;
  text-align: left;
}

.tosall {
  text-align: center;
  margin: 0 auto;
  padding: 10px 30px;
}

.center {
  text-align: center;
  padding-right: 300px;
}

.texttos {
  font-size: 25px;
  color: #000;
}

h3 {
  font-size: 30px;
}

.left {
  text-align: center;
}

.pink {
  text-align: center;
  color: hsl(0, 71%, 58%);
}

@media screen and (max-width: 480px) {

  /* 480px以下に適用されるCSS（スマホ用） */
  .texttos {
    font-size: 10px;
    color: #000;
  }

  h3 {
    font-size: 15px;
  }

  .pink {
    text-align: center;
    color: hsl(0, 71%, 58%);
  }

  .tos {
    width: 100%;
  }

  .center {
    text-align: center;
    padding-right: 0px;
  }
}
</style>